import { handleActions } from 'redux-actions';
import { CONSTANTES, LOGOUT } from '../actions';

const stateDefault = {
    indFlujoCompleto : false,
}

export default handleActions(
    {
        [CONSTANTES]: (state, action) => {
            return Object.assign({}, state, {indFlujoCompleto: action.payload});
        },
        [LOGOUT] : (state, action) => { 
            return Object.assign({}, stateDefault);
        },
    },
    stateDefault
);